import { cx } from './utils.js'

// Card / StatCard (migrated off Tailwind in Wave 47q). Styles live in
// .studio-card and .studio-stat-card-* rules in studio.css.

export function Card({ className, children, as: Component = 'div', ...props }) {
  return (
    <Component className={cx('studio-card', className)} {...props}>
      {children}
    </Component>
  )
}

export function StatCard({ label, value, tone = 'neutral', onClick }) {
  const Component = onClick ? 'button' : 'div'
  return (
    <Component
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={cx(
        'studio-stat-card',
        tone !== 'neutral' ? `tone-${tone}` : '',
        onClick ? 'clickable' : ''
      )}
    >
      <div className="studio-stat-card-label">{label}</div>
      <div className="studio-stat-card-value">{value}</div>
    </Component>
  )
}
